import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VPaginationGap' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ''
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    "aria-hidden": "true",
    class: _normalizeClass(_unref(clsx)(
			__props.className,
			'w-[2.25rem] select-none text-center text-sm/6 font-semibold text-zinc-950 dark:text-white'))
  }, " … ", 2))
}
}

})